export default {
  calendar: {
    today: 'Vandaag',
    tomorrow: 'Morgen',
    asap: 'Zo snel mogelijk',
  },
};
